export type HoraSlot = { index: number; period: 'day' | 'night'; planet: string; hindi: string; start: string; end: string; startLocal: string; endLocal: string };
export type HoraResult = { date: string; timezone: string; sunrise: string; sunset: string; nextSunrise: string; sunriseLocal: string; sunsetLocal: string; nextSunriseLocal: string; day: HoraSlot[]; night: HoraSlot[]; all: HoraSlot[]; previousNight: HoraSlot[] };
export function todayInZone(timezone: string) {
  const parts = new Intl.DateTimeFormat('en-CA', { timeZone: timezone, year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(new Date());
  const get = (type: string) => parts.find(part => part.type === type)?.value;
  return `${get('year')}-${get('month')}-${get('day')}`;
}
export function shiftDate(value: string, amount: number) {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) return todayInZone('Asia/Kolkata');
  const date = new Date(`${value}T12:00:00Z`);
  date.setUTCDate(date.getUTCDate() + amount);
  return date.toISOString().slice(0, 10);
}
export function currentHora(data: HoraResult, now: number): HoraSlot | null {
  return [...data.previousNight, ...data.all].find(slot => now >= Date.parse(slot.start) && now < Date.parse(slot.end)) || null;
}
